import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/dark.css";
import "./Input.css";
import Button from "../Button/Button";

export default function Input({ onChange, value, className, type = "text", error, ...rest }) {
	return (
		<div className="input_field_wrapper">
			<input
				type={type}
				onChange={onChange}
				value={value}
				className={`input ${className ?? ''}`}
				{...rest}
			/>
			{error && <span className="input_error_text">{error}</span>}
		</div>
	)
}

export function Textarea({ onChange, value, className, error, ...rest }) {
	return (
		<div className="input_field_wrapper">
			<textarea
				onChange={onChange}
				value={value}
				className={`input ${className ?? ''}`}
				{...rest}
			></textarea>
			{error && <span className="input_error_text">{error}</span>}
		</div>
	)
}

export function Checkbox({ onChange, onClick, checked, className, text, ...res }) {
	return (
		<label onClick={onClick} className={`checkbox ${className ?? ''}`}>
			<input
				onChange={onChange}
				type="checkbox"
				checked={checked}
				{...res}
			/>
			<div className="checkbox_input">
				&#10003;
			</div>
			{text &&
				<div className="checkbox_label">
					{text}
				</div>
			}
		</label>
	)
}


export function DateInput({ value, placeholder, onChange, allowClear, maxDate, minDate = '' }) {
	return (
		<div className="input_field_wrapper date_input_field">
			<Flatpickr
				value={value}
				className="input date_input"
				placeholder={placeholder}
				onChange={onChange}
				options={{
					disableMobile: true,
					maxDate,
					minDate,
					dateFormat: 'Y-m-d',
					locale: {
						firstDayOfWeek: 0,
						weekdays: {
							shorthand: ["S", "M", "T", "W", "T", "F", "S"],
							longhand: [
								"Sunday",
								"Monday",
								"Tuesday",
								"Wednesday",
								"Thursday",
								"Friday",
								"Saturday",
							]
						}
					},
				}}
			/>
			{allowClear && value &&
				<Button className={'clear_date'} onClick={(e) => { e.stopPropagation(); onChange([], '') }}>
					&#9932;
				</Button>
			}
		</div>
	)
}